document.addEventListener("DOMContentLoaded", function() {
    // Trigger een pageview voor de eerste pagina
    clarity("pageview");

    // Luister naar AJAX navigatie / Shopify events
    document.addEventListener("page:change", function() {
        clarity("pageview");
    });

    // Nieuwe pageview bij virtuele navigatie (Shopify 2.0 of AJAX thema's)
    (function(history){
        const pushState = history.pushState;
        history.pushState = function(state) {
        clarity("pageview");
        return pushState.apply(history, arguments);
        };
    })(window.history);
});